import 'intersection-observer';
import "babel-polyfill"
import { h } from "preact";
import habitat from "preact-habitat";
import GlobalContainer from "./components/layout/global-container";

let _habitat = habitat(GlobalContainer);
_habitat.render({
  clean: true,
  selector: '.dpa-global-top-bar-container'
});



// WEBPACK FOOTER //
// ./index.js